<template>
  <div>
    <h4 class="mb-2">角色编码：{{editModelTemp.userRoleCode}}</h4>
    <h4 class="mb-3">角色名称：{{editModelTemp.userRoleName}}</h4>

    <Card class="mb-5">
      <p slot="title">菜单权限</p>
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
        <Checkbox
          :indeterminate="indeterminate_menu"
          :value="checkAll_menu"
          @click.prevent.native="handleCheckAll_menu"
        >全选</Checkbox>
      </div>

      <CheckboxGroup v-model="checkPermissionCode_menu" @on-change="checkAllGroupChange_menu">
        <Checkbox
          :label="privilege.privilegeID"
          v-for="privilege in menuPrivilegeList"
          :key="privilege.privilegeID"
          border
          class="mb-3"
        >
          <span>{{privilege.privilegeName}}</span>
        </Checkbox>
      </CheckboxGroup>
    </Card>

    <Card>
      <p slot="title">功能权限</p>
      <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
        <Checkbox
          :indeterminate="indeterminate_normal"
          :value="checkAll_normal"
          @click.prevent.native="handleCheckAll_normal"
        >全选</Checkbox>
      </div>

      <CheckboxGroup v-model="checkPermissionCode_normal" @on-change="checkAllGroupChange_normal">
        <Checkbox
          :label="privilege.privilegeID"
          v-for="privilege in normalPrivilegeList"
          :key="privilege.privilegeID"
          border
          class="mb-3"
        >
          <span>{{privilege.privilegeName}}</span>
        </Checkbox>
      </CheckboxGroup>
    </Card>

    <div class="ml-5 mt-5 text-center modal-foter">
      <Button class="mr-5" @click="returnBack">取 消</Button>
      <Button type="success" @click="handleSubmit()" class="mr-5">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  data: function () {
    return {
      menuPrivilegeList: [], //菜单权限
      normalPrivilegeList: [], //功能权限
      privilegeAll: [], //全部权限

      indeterminate_menu: false,
      checkAll_menu: false,
      checkPermissionCode_menu: [],

      indeterminate_normal: true,
      checkAll_normal: false,
      checkPermissionCode_normal: [],
    };
  },

  created: function () {
    this.editModel = this.editModelTemp;
    this.getPrivilegeAll();
    this.getRolePrivilege();
  },

  methods: {
    handleSubmit: function () {
      let checkmenu = this.checkPermissionCode_menu;
      let checkmenuArr = [];
      let that=this;
      for (let id of checkmenu) {
        let  privilege= that.privilegeAll.find(p => p.privilegeID == id);
        let obj = { PrivilegeId: id, PrivilegeType:privilege.privilegeType, PrivilegeCode: privilege.privilegeCode };
        checkmenuArr.push(obj);
      }

      let checknormal = this.checkPermissionCode_normal;
      let checknormalArr = [];
      for (let id of checknormal) {
          let  privilege= that.privilegeAll.find(p => p.privilegeID == id);
        let obj = { PrivilegeId: id, PrivilegeType:privilege.privilegeType, PrivilegeCode: privilege.privilegeCode };
        checknormalArr.push(obj);
      }

      var PrivilegeModels = [...checkmenuArr, ...checknormalArr];

      let data = {
        RoleId: this.editModel.userRoleID,
        PrivilegeModels: PrivilegeModels,
      };
      this.$api.post("role/setRolePrivilege", data).then((rsp) => {
        if (rsp != false) {
          this.$Message.success("配置成功");
          this.returnBack();
          this.resetData();
          this.$emit("loadData");
        }
      });
    },

    //获取全部的权限
    getPrivilegeAll() {
      this.$api.get(`/privilege/getListAll`).then((rsp) => {
        if (rsp != false) {
          this.privilegeAll = rsp.data;
          console.log('超级管理员权限数据', this.privilegeAll);
          this.menuPrivilegeList = this.privilegeAll.filter(
            (p) => p.privilegeType == "0"
          );
          this.normalPrivilegeList = this.privilegeAll.filter(
            (p) => p.privilegeType == "1"
          );
        }
      });
    },

    //获取当前角色的功能权限
    getRolePrivilege() {
      let roleId = this.editModel.userRoleID;
      this.$api.get(`/role/getRolePrivilege?roleId=${roleId}`).then((rsp) => {
        if (rsp != false) {
          let result = rsp.data;
          let menuList = result.filter((p) => p.privilegeType == "0");
          for (let obj of menuList) {
            this.checkPermissionCode_menu.push(obj.privilegeId);
          }

          let normalList = result.filter((p) => p.privilegeType == "1");
          for (let obj of normalList) {
            this.checkPermissionCode_normal.push(obj.privilegeId);
          }
        }
      });
    },

    returnBack: function () {
      this.$emit("close");
    },

    handleCheckAll_menu() {
      if (this.indeterminate_menu) {
        this.checkAll_menu = false;
      } else {
        this.checkAll_menu = !this.checkAll_menu;
      }
      this.indeterminate_menu = false;
      if (this.checkAll_menu) {
        let allPages = [];
        this.menuPrivilegeList.forEach((item) => {
          allPages.push(item.privilegeID);
        });
        this.checkPermissionCode_menu = allPages;
      } else {
        this.checkPermissionCode_menu = [];
      }
    },

    checkAllGroupChange_menu(data) {
      if (data.length === this.menuPrivilegeList.length) {
        this.indeterminate_menu = false;
        this.checkAll_menu = true;
      } else if (data.length > 0) {
        this.indeterminate_menu = true;
        this.checkAll_menu = false;
      } else {
        this.indeterminate_menu = false;
        this.checkAll_menu = false;
      }
    },

    handleCheckAll_normal() {
      if (this.indeterminate_normal) {
        this.checkAll_normal = false;
      } else {
        this.checkAll_normal = !this.checkAll_normal;
      }
      this.indeterminate_normal = false;
      if (this.checkAll_normal) {
        let allPages = [];
        this.normalPrivilegeList.forEach((item) => {
          allPages.push(item.privilegeID);
        });
        this.checkPermissionCode_normal = allPages;
      } else {
        this.checkPermissionCode_normal = [];
      }
    },

    checkAllGroupChange_normal(data) {
      if (data.length === this.normalPrivilegeList.length) {
        this.indeterminate_normal = false;
        this.checkAll_normal = true;
      } else if (data.length > 0) {
        this.indeterminate_normal = true;
        this.checkAll_normal = false;
      } else {
        this.indeterminate_normal = false;
        this.checkAll_normal = false;
      }
    },
  },
};
</script>
<style scoped>
</style>